export default __webpack_public_path__ + "static/media/high-resistance-varnish.15ee17f7.svg";